import { Notification } from "../../notifications/domain";
import { Booking } from "./booking";

export class UpcomingBooking {
  constructor(
    public readonly booking: Booking,
    public readonly notification: Notification | null
  ) {}
}
